<div class="modal-body margin-bottom mb8">
    <div class="text-center">
        <div [ngClass]="{'mb-3': !isAcmic}">
            <ng-container *ngIf="!isAcmic; else acmicCloseIcon">
                <img src="./assets/img/images/icon-check-circle-mapfre.svg" alt="check circle icon" />
            </ng-container>
            <ng-template #acmicCloseIcon>
                <img src="./assets/img/images/icon-check-circle-acmic.svg" alt="check circle icon" />
            </ng-template>
        </div>

        <ng-container *ngIf="isAcmic; else maStateBody">
            <h1 class="title-copy"> {{ thanksMessage | translate }}</h1>
            <div class="margin-bottom mb2 margin-top mt8">{{ copyToYourEmailMessage | translate }}</div>
            <div><strong>{{ emailAddress }}</strong></div>
            <div class="margin-bottom mb16 margin-top mt24">{{ 'BILLING_COMMENT_PARAGRAPH_TWO' | translate }}</div>
        </ng-container>
        <ng-template #maStateBody>
            <h1 class="title-copy mb-0 col-2d373d"> {{ 'THANKS_SEND_MSG' | translate }}</h1>
            <div class="reply-message mb-3 mt-4 col-2d373d">
                {{ 'REPLY_TWO_DAYS' | translate }}
            </div>        
            <div class="margin-bottom lh-24 col-2d373d">{{ 'COPY_TO_YOUR_EMAIL' | translate }}</div>
            <div class="email-address lh-24 col-2d373d"><strong>{{ emailAddress }}</strong></div>
        </ng-template>

    </div>
    <ng-container *ngIf="isAcmic; else maCloseBtn">
        <div class="row text-center margin-top mt24">
            <div class="col">
                <mapfre-button additionalClasses="link-button small blue-link" [iconClasses]="'align-middle'" (click)="onClickBack()"> {{ 'CLOSE' | translate }}
                </mapfre-button>
            </div>
        </div>
    </ng-container>
    <ng-template #maCloseBtn>
        <ng-container *ngIf="!commentType; else otherRequest">
            <!-- <hr class="ma-hr-tag"> -->
            <div class="row  text-center margin-top mt24">
                <div class="col">
                    <mapfre-button [additionalClasses]="'basic primary large-btn waves-effect'" [iconClasses]="'align-middle'"
                        (click)="onClickBack()"> {{ 'CLOSE' | translate }}
                    </mapfre-button>
                </div>
            </div>
        </ng-container>

        <ng-template #otherRequest>
            <div class="row text-center margin-top mt24">
                <div class="col">                  
                    <mapfre-button 
                    [additionalClasses]="'basic primary large-btn waves-effect'"
                    [iconClasses]="'align-middle'"
                    (click)="onClickBack()"> {{ 'CLOSE' | translate }}
                    </mapfre-button>
                </div>                
                </div>
        </ng-template>
    </ng-template>
</div>